module.exports = __webpack_public_path__ + "static/Cel2_mobile-9a83e3fe7d0023c2e952244be434f7da.mp4";